var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 3,
    fill: "#4A4A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17A5 5 0 0 1 11 17",
    fill: "#4A4A4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5.5,
    r: 3.5,
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18A6 6 0 0 1 20 18",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplefill);
export default __webpack_public_path__ + "static/media/people.fill.326aec393c97454acbf67a0afa94c757.svg";
export { ForwardRef as ReactComponent };